/**
 * The session context and its accessor.
 *
 * Kept apart from `AuthProvider.tsx` so that file exports only a component — React Fast
 * Refresh can only hot-swap a module whose exports are all components. The split also
 * means a page can import `useAuth` without pulling the provider implementation in.
 */

import { createContext, useContext } from 'react'

import type { Principal } from '../api/endpoints'

export type AuthStatus = 'checking' | 'anonymous' | 'authenticated'

export interface AuthValue {
  status: AuthStatus
  principal: Principal | null
  login: (username: string, password: string) => Promise<void>
  logout: () => void
}

export const AuthContext = createContext<AuthValue | null>(null)

export function useAuth(): AuthValue {
  const context = useContext(AuthContext)
  if (!context) throw new Error('useAuth must be used inside <AuthProvider>')
  return context
}
